// extracted by mini-css-extract-plugin
export var actionButton = "_id-0";
export var fileInput = "_id-2";
export var paperclip = "_id-1";